export default __webpack_public_path__ + "static/media/finalcut.0eda2ea5.png";